import { useCallback } from "react";
import { longPollingActiveRequestsLSKey } from "variables/localStorageItemsNames";

export const useRequestsToLocalStorageManager = () => {
  const getRequests = useCallback(() => {
    try {
      return (
        JSON.parse(localStorage.getItem(longPollingActiveRequestsLSKey)) || {}
      );
    } catch {
      return {};
    }
  }, []);

  const saveRequest = useCallback(
    (requestId, data) => {
      const requests = getRequests();
      requests[requestId] = data;
      localStorage.setItem(
        longPollingActiveRequestsLSKey,
        JSON.stringify(requests),
      );
    },
    [getRequests],
  );

  const removeRequest = useCallback(
    (requestId) => {
      const requests = getRequests();
      delete requests[requestId];
      localStorage.setItem(
        longPollingActiveRequestsLSKey,
        JSON.stringify(requests),
      );
    },
    [getRequests],
  );

  return { getRequests, saveRequest, removeRequest };
};
